module.exports = __webpack_public_path__ + "static/img/nfl-alumni.85783ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nfl-alumni.png
// module id = Ezpv
// module chunks = 1